import React from 'react';
import classNames from 'classnames';
import { addDays, addHours, addYears } from 'date-fns';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Tooltip } from 'primereact/tooltip';
import { FaCalendarAlt } from 'react-icons/fa';
import { CalendarPague, InputNumberPague } from '../../../../../../../styles/primeReactConfig.js';
import { getRecebivelDropdownPt } from '../shared/PrimeDropdownProps.js';

/**
 * @typedef {object} RecebivelMainFieldsProps
 * @property {string|number} recebivelTipoId
 * @property {{label: string, value: string|number}[]} recebivelTipos
 * @property {(value: string|number) => void} setRecebivelTipoId
 * @property {number|string|null} recebivelTipoValor
 * @property {(value: number|string|null) => void} setRecebivelTipoValor
 * @property {Date|string|null} recebivelTipoDataInicio
 * @property {(value: Date|string|null) => void} setRecebivelTipoDataInicio
 * @property {Date|string|null} recebivelTipoDataFim
 * @property {(value: Date|string|null) => void} setRecebivelTipoDataFim
 */

/**
 * Bloco principal de campos do formulario de recebivel.
 *
 * @param {RecebivelMainFieldsProps} props
 * @returns {JSX.Element}
 */
export default function RecebivelMainFields(props) {
    const {
        recebivelTipoId,
        recebivelTipos,
        setRecebivelTipoId,
        recebivelTipoValor,
        setRecebivelTipoValor,
        recebivelTipoDataInicio,
        setRecebivelTipoDataInicio,
        recebivelTipoDataFim,
        setRecebivelTipoDataFim,
    } = props;

    const currentDate = addHours(new Date(), 3);
    const yearRange = `${currentDate.getFullYear()}:${addYears(currentDate, 3).getFullYear()}`;

    return (
        <div className='w-full flex md:flex-row flex-col gap-4'>
            <div className="flex flex-col w-full md:w-1/2 gap-2">
                <div className="flex flex-col">
                    <label htmlFor="recebivel_tipo_descricao">Descrição</label>
                    <Dropdown
                        value={recebivelTipoId}
                        options={recebivelTipos}
                        onChange={e => setRecebivelTipoId(e.value)}
                        pt={getRecebivelDropdownPt()}
                    />
                </div>
                <div className="flex flex-col">
                    <label htmlFor="recebivel_tipo_valor">Valor do Boleto</label>
                    <InputNumber
                        value={recebivelTipoValor}
                        onValueChange={(e) => setRecebivelTipoValor(e.value)}
                        placeholder="ex: R$ 50"
                        prefix="R$ "
                        min={0}
                        maxFractionDigits={2}
                        pt={InputNumberPague}
                    />
                </div>
            </div>
            <div className="flex flex-col w-full md:w-1/2 gap-2">
                <div className="flex flex-col">
                    <label htmlFor="recebivel_tipo_data_inicio">Vencimento da primeira parcela</label>
                    <Calendar
                        minDate={addDays(addHours(new Date(), 3), 1)}
                        id="recebivel_tipo_data_inicio"
                        locale="pt-BR"
                        dateFormat="dd/mm/yy"
                        value={recebivelTipoDataInicio}
                        onChange={(e) => setRecebivelTipoDataInicio(e.value)}
                        placeholder="ex: 25/05/2022"
                        yearRange={yearRange}
                        showOnFocus={false}
                        showIcon
                        mask="99/99/9999"
                        className='cadastroBoletoAdimplencia'
                        pt={CalendarPague}
                        icon={<FaCalendarAlt className={
                            classNames('px-4 rounded-r-lg',
                                'w-[50px] h-full',
                                'bg-sky-400 text-white hover:bg-sky-500',
                                'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                            )}
                        />}
                    />
                </div>
                <div className="flex flex-col">
                    <label htmlFor="recebivel_tipo_data_fim" className='datafim'>Vencimento da última parcela</label>
                    <Tooltip target=".datafim"
                        content='Em caso de geração recorrente, não informar o último vencimento'
                        position='bottom' />
                    <Calendar
                        minDate={recebivelTipoDataInicio}
                        locale="pt-BR"
                        dateFormat="dd/mm/yy"
                        value={recebivelTipoDataFim}
                        onChange={(e) => {
                            setRecebivelTipoDataFim(e.value);
                        }}
                        placeholder="ex: 25/05/2022"
                        yearRange={yearRange}
                        showOnFocus={false}
                        showIcon
                        id="recebivel_tipo_data_fim"
                        mask="99/99/9999"
                        className='cadastroBoletoAdimplencia'
                        pt={CalendarPague}
                        icon={<FaCalendarAlt className={
                            classNames('px-4 rounded-r-lg',
                                'w-[50px] h-full',
                                'bg-sky-400 text-white hover:bg-sky-500',
                                'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                            )}
                        />}
                    />
                </div>
            </div>
        </div>
    );
}
